import React from 'react';
import { Atividade, Dependencia } from '../../models/atividade';
import DependencyChain from './DependencyChain';

const VisaoDependencias: React.FC<{ atividades: Atividade[]; dependencias: Dependencia[]; onSelecionar: (id: number) => void }> = props => (
  <DependencyChain {...props} modo='todas' />
);

export default VisaoDependencias;
